import { useAsyncCacheContext } from '../context'

/**
 * The function returns the context of the async cache.
 * @returns The `useAsyncCache` function returns the `context` object obtained from the
 * `useAsyncCacheContext` hook.
 */
export function useAsyncCache() {
  const context = useAsyncCacheContext()
  return context
}
